export * from './propertiesGet';
